import React, { FC } from "react";
import { setClass, TAnswerStatuses } from "../../../../../utils";
import { isMobile } from 'react-device-detect';
import { Cross } from "../../../../svgs";
import { getConfirmationClassName } from "../../../../../helpers";
import '../../../../../styles/components/chip.scss';

interface ChipProps {
  label: string;
  confirmationStatus?: TAnswerStatuses;
  remoteWorkIcon?: JSX.Element;
  onDelete?: () => void;
}

export const Chip: FC<ChipProps> = ({ label, confirmationStatus, remoteWorkIcon, onDelete}) => (
  <div className={setClass('member-chip', isMobile && 'mobile', !confirmationStatus && 'no-conformation-status')}>
    <div className='member-name-block'>
      <div className="icons">
        <div className={`confirmation-round ${getConfirmationClassName(confirmationStatus)}`} />
        {remoteWorkIcon ?? <div className='confirmation-round' />}
      </div>
      <span className='member-name-label'>{label}</span>
    </div>
    {onDelete && <Cross onClick={onDelete}/>}
  </div>
);
